import React from 'react';

const item = {
  image:
    "https://images.unsplash.com/photo-1705475388190-775066fd69a5?auto=format&fit=crop&w=1200&q=80",
  tagline: "Bold Action. Sustainable Solutions. Inclusive Impact.",
  paragraphs: [
    "We started FIGHN Initiatives because we believe no community should be left behind when it comes to good food, better health, and economic opportunity.",
    "Across Sub Saharan Africa, millions of hardworking farmers produce abundant crops, yet too much is lost before it reaches consumers. At the same time, families continue to struggle with poor nutrition while young people search for meaningful livelihoods. We knew there had to be a better way.",
    "FIGHN Initiatives were created to turn these challenges into opportunities by combining science, innovation, and local knowledge to build practical solutions that improve lives.",
    "FIGHN stands for Functional Instant Green Healthy Nutritious™ food flours. We are commercializing our patented FIGHN™ technology to transform underutilized crops and agricultural by-products into nutritious, shelf-stable food ingredients that create value from farm to table.",
    "We believe lasting impact comes when research leaves the laboratory and begins improving everyday lives. That is the journey of FIGHN. We are taking years of scientific research and transforming it into practical businesses that create healthier food, stronger rural economies, and more resilient communities."
  ],
  priorities: [
    {
      title: "Reducing Food Loss",
      text: "Too much food is wasted after harvest simply because farmers lack processing and storage options. Our technology helps preserve fresh crops within hours of harvest, extending shelf life for over a year while reducing waste and increasing value."
    },
    {
      title: "Improving Nutrition",
      text: "We believe healthier food should be accessible to everyone. Our nutrient-rich food flours are designed to provide more protein, fiber, vitamins, and essential minerals using crops that people already know and grow."
    },
    {
      title: "Creating Jobs and Prosperity",
      text: "Every processing hub creates new opportunities for farmers, women, young entrepreneurs, and local businesses. We are building value chains that keep more income within rural communities while strengthening local economies."
    },
    {
      title: "Building Climate Resilience",
      text: "By promoting climate-resilient indigenous crops and making better use of agricultural resources, we are helping create food systems that are more sustainable, productive, and prepared for the future."
    }
  ],
  quote: "Let us not grow weary in doing good, for in due season we will reap, if we do not give up.",
  citation: "Galatians 6:9"
};

function AboutUs() {
  return (
    <section id="about" className="max-w-6xl mx-auto px-6 sm:px-8 py-16 sm:py-24">
      {/* 
        By using items-start and flattening the grid structure, we can control 
        the exact stacking order using Tailwind's order utilities.
      */}
      <div className="grid md:grid-cols-2 gap-10 md:gap-x-14 md:gap-y-8 items-start">
        
        {/* 1. IMAGE: Always first on both mobile and desktop */}
        <div className="order-1 md:col-span-1 rounded-2xl overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.12)]">
          <img
            src={item.image}
            alt="Fighn food flours ingredients"
            className="w-full h-[260px] sm:h-[400px] object-cover"
          />
        </div>

        {/* 2. NARRATIVE TEXT: Second on mobile, Right column on desktop */}
        {/* md:row-span-2 allows the priorities below to slide right up under the image on desktop */}
        <div className="order-2 md:col-span-1 md:row-span-2 space-y-6">
          <div>
            <p className="text-grain font-semibold text-xs uppercase tracking-[0.2em] mb-3">
              About Fighn Initiatives
            </p>
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl text-forest mb-2 leading-tight">
              {item.tagline}
            </h2>
            <p className="text-ink/60 text-md font-medium">
              Functional Instant Green Healthy Nutrition
            </p>
          </div>

          <div className="space-y-4 text-ink/75 leading-relaxed text-justify text-sm sm:text-base">
            {item.paragraphs.map((para, idx) => (
              <p key={idx}>{para}</p>
            ))}
          </div>

          <blockquote className="border-l-4 border-forest pl-4 my-6 italic text-ink/80 text-sm bg-forest/5 py-3 rounded-r-xl">
            "{item.quote}"
            <cite className="block text-xs font-semibold text-grain mt-1 not-italic">— {item.citation}</cite>
          </blockquote>
        </div>

        {/* 3. PRIORITIES: Third on mobile (under the story), Left column (under image) on desktop */}
        <div className="order-3 md:col-span-1 space-y-6 pt-4 md:pt-0">
          <h3 className="font-display text-xl font-bold text-forest border-b border-forest/10 pb-2">
            Our Key Priorities
          </h3>
          <div className="grid gap-4 sm:grid-cols-2">
            {item.priorities.map((priority) => (
              <div key={priority.title} className="p-4 bg-white/50 rounded-xl border border-forest/5 shadow-sm">
                <h4 className="font-semibold text-forest text-sm mb-1">{priority.title}</h4>
                <p className="text-ink/70 text-xs leading-relaxed">{priority.text}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}

export default AboutUs;